/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_SecondsInputs */



/**
* | output |
* | --- |
* | "seconds (ss.mmm)" |
*
* @param {Transcript_Export_Timecode_Format_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_seconds = /** @type {((inputs?: Transcript_Export_Timecode_Format_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("secondes (ss.mmm)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekunden (ss.mmm)")
	if (locale === "it") return /** @type {LocalizedString} */ ("secondi (ss.mmm)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("секунд (сс.ммм)")
	if (locale === "es") return /** @type {LocalizedString} */ ("segundos (ss.mmm)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("秒（ss.mmm）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("秒（ss.mmm）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेकंड (एसएस.म्म)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("segundos (ss.mmm)")
	return /** @type {LocalizedString} */ ("seconds (ss.mmm)")
});